import React from "react";
import { FiStar } from "react-icons/fi";

/* IMPORTANT: these are placeholder quotes written to show how the layout
   will look with real feedback — they are not from actual customers.
   Nirkana hasn't completed real bookings yet (phase 1 hasn't launched),
   so these must be replaced with genuine client testimonials once real
   events have happened. Do not publish this section as-is. */
const testimonialsData = [
  { name: "Priya R.", location: "Adyar", feedback: "Booked a small birthday for my daughter and didn't have to chase a single vendor myself — the decor and cake showed up exactly as discussed." },
  { name: "Karthik S.", location: "Velachery", feedback: "Liked that the quote was one number upfront. No back and forth over separate decor and catering costs." },
  { name: "Meera N.", location: "T. Nagar", feedback: "The theme decor was better than what we asked for, honestly. Cake was on time and exactly the flavor we picked." },
  { name: "Arjun V.", location: "Anna Nagar", feedback: "Simple process — filled a short form, got a quote same day, and everything arrived a couple hours before the party started." },
  { name: "Divya K.", location: "Mylapore", feedback: "Photography add-on was worth it. Good candid shots without anyone feeling like there was a photographer hovering around." },
  { name: "Rahul M.", location: "Porur", feedback: "Went with the Classic package for a 30-guest party — catering combo covered everyone comfortably." },
];

const TestimonialCard = ({ t }) => (
  <div className="w-80 shrink-0 rounded-2xl bg-cloud p-6 mx-3">
    <div className="flex gap-1 text-gold">
      {Array.from({ length: 5 }).map((_, i) => (
        <FiStar key={i} size={14} fill="currentColor" />
      ))}
    </div>
    <p className="mt-4 italic text-muted">&ldquo;{t.feedback}&rdquo;</p>
    <p className="mt-4 text-sm font-medium text-charcoal">
      {t.name} <span className="font-normal text-muted">· {t.location}</span>
    </p>
  </div>
);

const Testimonials = () => {
  const looped = [...testimonialsData, ...testimonialsData];

  return (
    <section className="bg-paper py-16 lg:py-24">
      <div className="max-w-content mx-auto px-6 lg:px-10">
        <h2 className="text-3xl font-bold text-brand sm:text-4xl">What families say</h2>
      </div>

      <div className="mt-12 overflow-hidden">
        <div className="flex w-max animate-marquee hover:[animation-play-state:paused]">
          {looped.map((t, index) => (
            <TestimonialCard key={index} t={t} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
